
import React from 'react';
import { Share, GraduationCap } from 'lucide-react';

const CommunitySection: React.FC = () => {
  const communityItems = [
    "Real-time collaboration sessions",
    "Project sharing and feedback",
    "Networking events and community forums",
    "Direct messaging with collaborators"
  ];

  const learningItems = [
    "Music business courses and tutorials",
    "Marketing strategy guides",
    "Production technique workshops",
    "Industry expert webinars and Q&As"
  ];

  return (
    <section className="py-10 px-4 sm:px-6 md:px-8 lg:px-16 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="animate-fade-in">
          <h2 className="text-3xl font-bold text-white mb-4">Community & Collaboration</h2>
          <p className="text-white/70 mb-4">
            Join a thriving community of independent musicians. Collaborate on projects, 
            share knowledge, and grow together in our creative ecosystem.
          </p>
          <ul className="space-y-2">
            {communityItems.map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-white/80">
                <div className="h-5 w-5 rounded-full bg-gradient-to-r from-neon-purple to-neon-blue flex items-center justify-center">
                  <Share className="h-3 w-3 text-white" />
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>
        
        <div className="animate-fade-in" style={{ animationDelay: "0.2s" }}>
          <h2 className="text-3xl font-bold text-white mb-4">Learning & Growth</h2>
          <p className="text-white/70 mb-4">
            Access resources and tools designed to help you grow as an artist. 
            Learn music business strategies, marketing techniques, and creative skills.
          </p>
          <ul className="space-y-2">
            {learningItems.map((item, i) => (
              <li key={i} className="flex items-center gap-2 text-white/80">
                <div className="h-5 w-5 rounded-full bg-gradient-to-r from-neon-green to-neon-blue flex items-center justify-center">
                  <GraduationCap className="h-3 w-3 text-white" />
                </div>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CommunitySection;
